import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { ImpersonationRuleModel } from "../models/ImpersonationRuleModels/ImpersonationRuleModel";

import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";


@Injectable({
  providedIn: 'root'
})
export class ImpersonationRuleService {
  ApiUrl = "/api/admin/ImpersonationRule/"
  constructor(private http: RequestHandlerService) {
  }

  AddImpersonationRule(AddModel: ImpersonationRuleModel) {
    return this.http.post( this.ApiUrl + 'AddImpersonationRule', AddModel);
  }
  EditImpersonationRule( EditModel: ImpersonationRuleModel) {
   
    return this.http.post( this.ApiUrl + 'EditImpersonationRule', EditModel);
  }
  DeleteImpersonationRule( UsersIDRequestModel: UsersIDRequestModel) {
   
    return this.http.post( this.ApiUrl + 'DeleteImpersonationRule', UsersIDRequestModel);
  }
  Loaddropdowns()
  {
    
    return this.http.get(this.ApiUrl +'Loaddropdowns');
  }

  
}